<main class="fadeIn">
    <div class="container-fluid" #focusedElement>
        <div class="row">
            <div class="col-12">
                <div class="header d-flex justify-content-between">
                    <h1><small>&nbsp;</small>Rule Listing</h1>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="table-container table-responsive">
                    <table class="table table-list">
                        <caption class="d-none">Rule management list table body</caption>
                        <thead>
                            <tr>
                                <th scope="col" class="text-left"> Type of Rule
                                    <span *ngIf="ruleManageList?.length" class="sort-order" (click)="sortColumn('typeOfRule')">
                                        <a class="{{columnSort['typeOfRule'].sortType}} "></a>
                                    </span>
                                </th>
                                <th scope="col" class="text-left">Rules
                                    <span *ngIf="ruleManageList?.length"  class="sort-order" (click)="sortColumn('rule')">
                                        <a class="{{columnSort['rule'].sortType}} "></a>
                                    </span>
                                </th>
                                <!-- <th scope="col" class="text-left">Execution Order
                                    <span *ngIf="ruleManageList?.length" class="sort-order" (click)="sortColumn('sortOrder')">
                                        <a class="{{columnSort['sortOrder'].sortType}} "></a>
                                    </span>
                                </th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let rules of ruleManageList">
                                <td>{{rules.typeOfRule || '-'}}</td>
                                <td>{{rules.rule || '-'}}</td>
                                <!-- <td>{{rules.sortOrder}}</td> -->
                            </tr>
                        </tbody>
                    </table>
                    <div class="no-data with-border" *ngIf="!fetchingInProgress && !ruleManageList?.length">
                        <img src="./assets/images/icons/no-data-img.svg" alt="">
                        <p>No Results Found</p>
                    </div>
                </div>
                <app-navigation [isRuleListing]="true" [listLength]="totalCount" [pageNo]="page_no" (currentPageDetail)="currentPageDetail($event)" >
                </app-navigation>
            </div>
        </div>
    </div>
</main>
